import React, { useState, useRef, useMemo } from "react";
import IssuesSection from "../ProjectUpdates/IssuesSection";
import IssueDetailModal from "../ProjectUpdates/IssueDetailModal";
import AddIssueLogModal from "../ProjectUpdates/AddIssueLogModal";

export default function IssueLog({ projectId, projectDetails, isMobile }) {
  const [selectedIssueId, setSelectedIssueId] = useState(null);
  const [logIssueModalOpen, setLogIssueModalOpen] = useState(false);
  const issuesRefetchRef = useRef(null);

  const activityOptions = useMemo(
    () =>
      (projectDetails?.milestone || []).map((m) => ({
        value: m.id,
        label: String(m.milestone_name || m.name || `Milestone ${m.id}`).trim(),
      })),
    [projectDetails?.milestone]
  );

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16, width: "100%", padding: "0 8px" }}>
      <IssuesSection
        projectId={projectId}
        onLogIssueClick={() => setLogIssueModalOpen(true)}
        onIssueClick={(id) => setSelectedIssueId(id)}
        refetchRef={issuesRefetchRef}
      />

      <IssueDetailModal
        open={!!selectedIssueId}
        issueId={selectedIssueId}
        onClose={() => setSelectedIssueId(null)}
        onSuccess={() => {
          issuesRefetchRef.current?.();
          setSelectedIssueId(null);
        }}
      />

      <AddIssueLogModal
        isOpen={logIssueModalOpen}
        onClose={() => setLogIssueModalOpen(false)}
        onSuccess={() => {
          issuesRefetchRef.current?.();
          setLogIssueModalOpen(false);
        }}
        projectId={projectId}
        activityOptions={activityOptions}
        sourceId={null}
      />
    </div>
  );
}
